<script setup lang="ts">
import { LaunchPadItem } from "@/types/launch-pad-item";
import { useRouter } from "vue-router";

const props = defineProps<{
  items: LaunchPadItem[];
}>();

const router = useRouter();

function navigate(item) {
  if (item.route) {
    router.push(item.route);
  }
}
</script>

<template>
  <v-container class="fill-height d-flex align-center justify-center">
    <v-row class="launchpad-grid" justify="center">
      <v-col v-for="item in items" :key="item.text" cols="6" sm="4" md="3" lg="2">
        <v-card class="launchpad-tile" elevation="4" @click="navigate(item)">
          <div class="tile-content">
            <v-icon v-if="item.icon" size="36" class="mb-2">
              {{ item.icon }}
            </v-icon>

            <div class="tile-text">
              {{ item.text }}
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.launchpad-grid {
  max-width: 900px;
}

.launchpad-tile {
  aspect-ratio: 1 / 1;
  border-radius: 24px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(6px);
}

.launchpad-tile:hover {
  transform: scale(1.05);
}

.launchpad-tile:active {
  transform: scale(0.97);
}

.tile-content {
  text-align: center;
  padding: 16px;
}

.tile-text {
  font-size: 1.1rem;
  font-weight: 600;
}
</style>
